import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryTodayEvent } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: 'chart45',
      angle: 0
    };
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    getData: function getData() {
      var _this = this;

      queryTodayEvent().then(function (res) {
        if (res.success) {
          _this.initBarChart(res.result);
        }
      });
    },
    initBarChart: function initBarChart(value) {
      var data = [{
        name: '人脸识别',
        value: value.faceNum
      }, {
        name: '区域告警',
        value: value.evenNum
      }]; // 初始化数据

      var option = {
        series: [{
          data: [data[0]],
          type: 'gauge',
          name: data[0].name,
          title: {
            show: true,
            offsetCenter: [0, '195%'],
            color: '#fff',
            fontSize: 14
          },
          center: ['25%', '30%'],
          radius: '50%',
          startAngle: '220',
          endAngle: '-40',
          splitNumber: '12',
          pointer: {
            show: true,
            length: '80%'
          },
          itemStyle: {
            normal: {
              color: {
                x: '0.00',
                y: '0.00',
                x2: '1.00',
                y2: '1.00',
                type: 'linear',
                global: false,
                colorStops: [{
                  offset: 1,
                  color: '#AF6030'
                }, {
                  offset: 0,
                  color: '#EED25F'
                }]
              }
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 8,
              color: [[1, new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: '#2081DF'
              }, {
                offset: 0.5,
                color: '#91FCC1'
              }, {
                offset: 1,
                color: '#2081DF'
              }])]]
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            length: 8,
            lineStyle: {
              color: '#031544',
              width: 2
            }
          },
          axisLabel: {
            show: false
          },
          detail: {
            show: true,
            offsetCenter: [0, '125%'],
            color: '#B7EBFE',
            fontSize: 20,
            fontFamily: 'hkxzyW7'
          }
        }, {
          data: [data[1]],
          type: 'gauge',
          name: data[1].name,
          title: {
            show: true,
            offsetCenter: [0, '195%'],
            color: '#fff',
            fontSize: 14
          },
          center: ['65%', '30%'],
          radius: '50%',
          startAngle: '220',
          endAngle: '-40',
          splitNumber: '12',
          pointer: {
            show: true,
            length: '80%'
          },
          itemStyle: {
            normal: {
              color: {
                x: '0.00',
                y: '0.00',
                x2: '1.00',
                y2: '1.00',
                type: 'linear',
                global: false,
                colorStops: [{
                  offset: 1,
                  color: '#AF6030'
                }, {
                  offset: 0,
                  color: '#EED25F'
                }]
              }
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 8,
              color: [[1, new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: '#2081DF'
              }, {
                offset: 0.5,
                color: '#91FCC1'
              }, {
                offset: 1,
                color: '#2081DF'
              }])]]
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            length: 8,
            lineStyle: {
              color: '#031544',
              width: 2
            }
          },
          axisLabel: {
            show: false
          },
          detail: {
            show: true,
            offsetCenter: [0, '125%'],
            color: '#B7EBFE',
            fontSize: 20,
            fontFamily: 'hkxzyW7'
          }
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};